import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { PrInitiatorService } from 'src/app/modules/pr-initiator/services/pr-initiator.service';
import { PrBuyerDashboardService } from '../../services/pr-buyer-dashboard.service';
import { PrBuyerHelperService } from '../../services/pr-buyer-helper.service';

interface FileSize {
  file: File,
  formatSize: string
}

@Component({
  selector: 'app-upload-rc',
  templateUrl: './upload-rc.component.html',
  styleUrls: ['./upload-rc.component.scss']
})
export class UploadRCComponent implements OnInit {
  public title !: string;
  public prFiles: Array<FileSize> = [];
  public onClose = new Subject<any>();

  constructor(public bsModalRef: BsModalRef,
    private _prBuyerHelperService: PrBuyerHelperService,
    private _toastrService: ToastrService,
    private _loaderService: NgxUiLoaderService,
    private _prBuyerDashboardService: PrBuyerDashboardService) { }

  ngOnInit(): void {
  }

  public onModalClose(): void {
    this.onClose.next('Success');
    this.bsModalRef.hide();
  }

  public verifyFile(event: any): void {
    [...event.target.files].forEach((file: File) => {
        this.prFiles.push({ file, formatSize: this._prBuyerHelperService.formatFileSize(file.size) });
    });
  }

  public clearFile(): void {
    this.prFiles = [];
  }

  public onUploadFile(): void {
    this._loaderService.start();
    const formData = new FormData();
    for (var i = 0; i < this.prFiles.length; i++) {
      formData.append("file", this.prFiles[i].file);
    }
    this._prBuyerDashboardService.addBuyerContractData(formData).subscribe(res => {
      this._toastrService.success(res.message);
      this.onModalClose();
      this._loaderService.stop();
    }, err => {
      this._toastrService.error(err.error.message);
      this._loaderService.stop();
    });
  }
}
